<template>
  <div class="menu-bar">
    <div class="menu-header">
      <h3 class="app-title">📱 Microboss Panel</h3>
      <div v-if="username" class="menu-username">👤 {{ username }}</div>
    </div>
    <nav class="menu-nav">
      <ul class="menu-list">
        <li class="menu-item">
          <router-link to="/overview" class="menu-link" :class="{ active: isActive('/overview') }">
            🏠 Overview
          </router-link>
        </li>
        <li class="menu-item">
          <router-link to="/" class="menu-link" :class="{ active: isActive('/') }">
            📄 PDF Uploader
          </router-link>
        </li>
        <li class="menu-item">
          <router-link to="/smm-report" class="menu-link" :class="{ active: isActive('/smm-report') }">
            📊 Social Report
          </router-link>
        </li>
        <li class="menu-section">Campaign Tools</li>
        <li class="menu-item">
          <router-link to="/campaign-dashboard" class="menu-link" :class="{ active: isActive('/campaign-dashboard') }">
            📈 Campaign Dashboard
          </router-link>
        </li>
        <li class="menu-item" v-if="canAccessDcmDashboard">
          <router-link to="/upload-studio" class="menu-link" :class="{ active: isActive('/upload-studio') }">
            📤 Upload Studio
          </router-link>
        </li>
        <li class="menu-item" v-if="canAccessDcmManagement">
          <router-link to="/dcm-management" class="menu-link" :class="{ active: isActive('/dcm-management') }">
            🎬 DCM Management
          </router-link>
        </li>
        <li class="menu-item" v-if="canAccessCreativeDashboard">
          <router-link to="/creative-dashboard" class="menu-link" :class="{ active: isActive('/creative-dashboard') }">
            🎨 Creative Dashboard
          </router-link>
        </li>
        <li class="menu-item" v-if="canAccessDcmDashboard">
          <router-link to="/dcm-dashboard" class="menu-link" :class="{ active: isActive('/dcm-dashboard') }">
            📥 DCM Dashboard
          </router-link>
        </li>
        <li class="menu-item" v-if="canAccessCampaignSetup">
          <router-link to="/sponsor-management" class="menu-link" :class="{ active: isActive('/sponsor-management') }">
            🤝 Sponsor Management
          </router-link>
        </li>
        <li class="menu-item" v-if="canAccessCampaignSetup">
          <router-link to="/sponsor-reports" class="menu-link" :class="{ active: isActive('/sponsor-reports') }">
            🔗 Sponsor Reports
          </router-link>
        </li>
        <li class="menu-item" v-if="canAccessUploadLinks">
          <router-link to="/upload-links" class="menu-link" :class="{ active: isActive('/upload-links') }">
            📎 Upload Links
          </router-link>
        </li>
        <li class="menu-item" v-if="isSuperUser">
          <router-link to="/admin" class="menu-link" :class="{ active: isActive('/admin') }">
            🔐 Admin Panel
          </router-link>
        </li>
        <li class="menu-item" v-if="isSuperUser">
          <router-link to="/admin/users" class="menu-link" :class="{ active: isActive('/admin/users') }">
            👥 Admin Users
          </router-link>
        </li>
        <li class="menu-item" v-if="isSuperUser">
          <router-link to="/admin/features" class="menu-link" :class="{ active: isActive('/admin/features') }">
            ⚙️ Admin Features
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="menu-footer">
      <button class="logout-link" @click="logout">
        🚪 Logout
      </button>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  name: 'MenuBar',
  data() {
    return {
      isSuperUser: false,
      userRole: '',
      username: ''
    };
  },
  computed: {
    canAccessCampaignSetup() {
      const role = String(this.userRole || '').toLowerCase();
      return this.isSuperUser || ['admin', 'marketing', 'markting'].includes(role);
    },
    canAccessDcmManagement() {
      const role = String(this.userRole || '').toLowerCase();
      return this.isSuperUser || ['admin', 'marketing', 'markting', 'dcm'].includes(role);
    },
    canAccessCreativeDashboard() {
      const role = String(this.userRole || '').toLowerCase();
      return this.isSuperUser || role === 'creative';
    },
    canAccessDcmDashboard() {
      const role = String(this.userRole || '').toLowerCase();
      return this.isSuperUser || role === 'dcm';
    },
    canAccessUploadLinks() {
      const role = String(this.userRole || '').toLowerCase();
      return this.isSuperUser || ['admin', 'dcm'].includes(role);
    }
  },
  async mounted() {
    try {
      const res = await api.get('/check');
      this.isSuperUser = !!res.data.isSuperUser;
      this.userRole = res.data.role || '';
      this.username = res.data.user || '';
    } catch (err) {
      this.isSuperUser = false;
      this.userRole = '';
    }
  },
  methods: {
    isActive(path) {
      if (path === '/admin') {
        return this.$route.path === '/admin';
      }
      return this.$route.path === path;
    },
    async logout() {
      try {
        await api.post('/logout');
        this.$router.push('/login');
      } catch (err) {
        console.error('Logout error:', err);
        this.$router.push('/login');
      }
    }
  }
};
</script>

<style scoped>
.menu-bar {
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  color: #ecf0f1;
  height: 100vh;
  width: 250px;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.menu-header {
  padding: 20px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
}

.app-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #3498db;
  letter-spacing: 0.5px;
}

.menu-username {
  margin-top: 8px;
  font-size: 13px;
  color: rgba(236, 240, 241, 0.7);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-nav {
  flex: 1;
  padding: 20px 0;
}

.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  margin: 0;
}

.menu-section {
  margin: 12px 0 4px;
  padding: 6px 20px;
  font-size: 11px;
  font-weight: 700;
  color: #8fb7d9;
  letter-spacing: 0.7px;
  text-transform: uppercase;
}

.menu-link {
  display: block;
  padding: 16px 20px;
  color: #ecf0f1;
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  font-size: 15px;
  font-weight: 500;
}

.menu-link:hover {
  background: rgba(255, 255, 255, 0.1);
  border-left-color: #3498db;
}

.menu-link.active {
  background: rgba(52, 152, 219, 0.2);
  border-left-color: #3498db;
  color: #3498db;
  font-weight: 600;
}

.menu-footer {
  padding: 20px;
  border-top: 2px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
}

.logout-link {
  display: block;
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  border: none;
  border-radius: 6px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  font-family: inherit;
}

.logout-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);
}

.logout-link:active {
  transform: translateY(0);
}

/* Responsive: Tablet */
@media (max-width: 768px) {
  .menu-bar {
    width: 200px;
  }

  .menu-header {
    padding: 16px;
  }

  .app-title {
    font-size: 16px;
  }

  .menu-link {
    padding: 12px 16px;
    font-size: 14px;
  }

  .menu-footer {
    padding: 16px;
  }

  .logout-link {
    padding: 10px 12px;
    font-size: 13px;
  }
}

/* Responsive: Mobile */
@media (max-width: 480px) {
  .menu-bar {
    width: 100%;
    height: auto;
    position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
  }

  .menu-header {
    border-bottom: none;
    border-right: 2px solid rgba(255, 255, 255, 0.1);
    padding: 8px 12px;
    flex: 0 0 auto;
  }

  .app-title {
    font-size: 14px;
    margin: 0;
  }

  .menu-nav {
    flex: 1;
    padding: 0;
    display: flex;
    overflow-x: auto;
  }

  .menu-list {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
  }

  .menu-item {
    flex: 1;
    min-width: 80px;
  }

  .menu-section {
    display: none;
  }

  .menu-link {
    padding: 10px 8px;
    text-align: center;
    border-left: none;
    border-bottom: 3px solid transparent;
    font-size: 12px;
  }

  .menu-link:hover {
    border-left: none;
    border-bottom-color: #3498db;
  }

  .menu-link.active {
    border-left: none;
    border-bottom-color: #3498db;
  }

  .menu-footer {
    border-top: none;
    border-left: 2px solid rgba(255, 255, 255, 0.1);
    padding: 8px 12px;
    flex: 0 0 auto;
  }

  .logout-link {
    width: auto;
    padding: 8px 12px;
    font-size: 12px;
  }
}
</style>
